<template>
  <div class="form-out-view">
    <!-- //添加修改专业能力 -->
    <UserTitle :title="title"></UserTitle>
    <b-row class="form-all">
      <b-col cols="12" md="12">
        <a-form-item label="选择专业能力" v-if="type == 'add'">
          <a-select style="width: 100%" @change="handleChange">
            <a-select-option
              :value="item.id"
              v-for="(item, index) in option"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </b-col>
    </b-row>
    <FormContext
      :data="formData"
      @selectBack="selectBack"
      :Formtype="type"
    ></FormContext>
  </div>
</template>
<script>
import Api from "@/apis";
export default {
  data() {
    return {
      title: "编辑专业能力",
      option: [],
      formData: [],
      formId: this.$route.query.formId || 0,
      id: this.$route.query.id || 0,
      type: this.$route.query.type || "add",
      sexOption: [
        {
          text: "男",
          value: 0
        },
        {
          text: "女",
          value: 1
        }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let query = {
        current: 1,
        type: "ability"
      };
      const getFormData = await Api.Form.getForm(query);
      if (getFormData.data.length > 0) {
        this.option = getFormData.data;
      }
      //修改
      if (this.type == "edit" && this.id !== 0) {
        const getAbilities = await Api.User.getAbilitiesId(
          this.id,
          this.formId
        );
        if (getAbilities) {
          this.formData = getAbilities.records;
        }
      }
    },
    //选择表单后
    async handleChange(val) {
      try {
        //选中表单
        const getForm = await Api.Form.getFormId(val);
        if (getForm) {
          //获得字段
          const FormFiled = await Api.Form.getFormField(getForm.id);
          if (FormFiled && FormFiled.data) {
            //传递子组件
            this.formData = FormFiled.data;
          }
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    async selectBack(data) {
      try {
        if (this.type == "add") {
          const addForm = await Api.User.createAbilities(data);
          if (addForm) {
            this.$message.success("添加成功");
            this.$router.push("/user/talent");
          } else {
            this.$message.error("添加失败");
          }
        } else {
          const addForm = await Api.User.editAbilities(data, this.id);
          if (addForm) {
            this.$message.success("修改成功");
            this.$router.push("/user/talent");
          } else {
            this.$message.error("修改失败");
          }
        }
      } catch (e) {
        this.$message.error(e);
      }
    }
  }
};
</script>
<style scoped></style>
